
import BaseDynamicComponent from "@/app/dynamic-components/forms/form-components/form-component.base";
import {Component} from "vue-property-decorator";
import TextArea from "@/components/common/Textarea.vue";
import DynamicComponentConfigManager from "@/app/components/configmanager/dynamic-component-config-manager.vue";

export type TextAreaMetaData = {
  label?: string;
  disabled?: boolean;
  value?: string;
};

@Component({
  components: {DynamicComponentConfigManager, TextArea },
})
export default class TextAreaBase extends BaseDynamicComponent<TextAreaMetaData> {
  mounted(): void {
    return;
  }

  maxLengthValidator(): number | undefined{
    if(!this.entry?.validators || this.entry.validators.length <= 0) return undefined;
    const maxLengthValidators = this.entry.validators.filter(value => value.getKey() === 'maxLength');
    if(maxLengthValidators.length <= 0) return undefined;

    return maxLengthValidators.map(value => value.getParam(0)).filter(value => !!value).reduce((previousValue, currentValue) => {
      return Math.max(previousValue, currentValue);
    });
  }

  onTextFieldContentChanged(newValue: string) {
    this.setValueView(newValue);
  }
}
